import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/logo-kjd.webp';

function WidAbout() {
    return (
        <div className="single-footer-wid site_info_box">
            <Link to="/" className="f_logo">
                <img src={logo} alt="KJD Logo" />
            </Link>
            <p>
                CV. Kalimantan Jaya Diesel is a professional supplier of genuine and replacement
                heavy equipment parts, serving customers across Indonesia since 2005.
            </p>
            <Link to="/contact" className="theme-btn theme-2 mt-30">
                Contact Us <BsArrowRight style={{ marginLeft: '5px' }} />
            </Link>
            <div className="social_link">
                <a
                    href="https://www.instagram.com/kalimantanjayadiesel/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <FaInstagram />
                </a>
                <a
                    href="https://wa.me/628115190088"
                    target="_blank"
                    rel="noreferrer"
                >
                    <FaWhatsapp />
                </a>
            </div>
        </div>
    );
}

export default WidAbout;
